import { useEffect, useState } from "react";

// Lightweight hash router: "" or "#/" => directory, "#/organigrama" => orgchart
// "#/angajat/{id}" => directory with profile modal open
export function useHashRoute() {
  const [hash, setHash] = useState(window.location.hash || "#/");
  useEffect(() => {
    const onHash = () => setHash(window.location.hash || "#/");
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const view = hash.startsWith("#/organigrama")
    ? "orgchart"
    : hash.startsWith("#/matricial")
      ? "matrix"
      : hash.startsWith("#/insights")
        ? "insights"
        : "directory";
  let profileId = null;
  const m = hash.match(/^#\/angajat\/(\d+)/);
  if (m) profileId = parseInt(m[1], 10);

  return {
    hash,
    view,
    profileId,
    goToDirectory: () => { window.location.hash = "#/"; },
    goToOrgChart: () => { window.location.hash = "#/organigrama"; },
    goToMatrix: () => { window.location.hash = "#/matricial"; },
    goToInsights: () => { window.location.hash = "#/insights"; },
    openProfile: (id) => { window.location.hash = `#/angajat/${id}`; },
    closeProfile: () => {
      if (window.location.hash.startsWith("#/angajat")) {
        const target = view === "orgchart" ? "#/organigrama"
          : view === "matrix" ? "#/matricial"
          : view === "insights" ? "#/insights" : "#/";
        window.location.hash = target;
      }
    },
  };
}
